var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import styled from "styled-components";
import EditorRemoveIcon from "@atlaskit/icon/glyph/editor/remove";
import VidPlayIcon from "@atlaskit/icon/glyph/vid-play";
import { colors } from "@atlaskit/theme";
import { Card, Link, useShowFlag } from "@atlassiansox/microscopekit";
import { LoadingButton } from "@atlaskit/button";
import { ClickableIconContainer, FormModal } from "../../../components";
import { useMutationUI } from "../../../hooks";
import { DisableExerciseTemplateMappingMutation, StartWargameMutation, ScheduleType } from "../../../graphql";
export var WargamePlanCard = function (_a) {
    var wargamePlan = _a.wargamePlan, wargameExerciseId = _a.wargameExerciseId, isExecutionAllowed = _a.isExecutionAllowed, isExerciseActive = _a.isExerciseActive, isWargameActive = _a.isWargameActive;
    var _b = __read(useState(false), 2), isRemoveConfirmationVisible = _b[0], setIsRemoveConfirmationVisible = _b[1];
    var showRemoveConfirmation = function () { return setIsRemoveConfirmationVisible(true); };
    var hideRemoveConfirmation = function () { return setIsRemoveConfirmationVisible(false); };
    var _c = useExecuteWargame(wargamePlan.id, wargameExerciseId), executeWargame = _c.executeWargame, isExecutingWargame = _c.isExecutingWargame;
    var _d = useRemoveWargamePlan(wargamePlan.id, wargameExerciseId, hideRemoveConfirmation), removeWargamePlan = _d.removeWargamePlan, isRemovingWargamePlan = _d.isRemovingWargamePlan;
    var removeIconColor = isExerciseActive ? colors.R400 : colors.N50;
    var onRemove = isExerciseActive ? showRemoveConfirmation : undefined;
    var showFlag = useShowFlag();
    var onExecute = function () {
        if (isWargameActive) {
            showFlag({
                type: "error",
                title: "Error",
                message: "Cannot execute a wargame plan while another execution is in progress"
            });
        }
        else {
            executeWargame();
        }
    };
    return (React.createElement(Card, null,
        React.createElement(Header, null,
            React.createElement("h4", null, wargamePlan.name),
            React.createElement(ClickableIconContainer, null,
                React.createElement(EditorRemoveIcon, { label: "Delete Wargame Plan", primaryColor: removeIconColor, onClick: onRemove }))),
        React.createElement("br", null),
        React.createElement("div", null,
            React.createElement(LoadingButton, { appearance: "primary", iconBefore: React.createElement(VidPlayIcon, { label: "Execute Wargame Plan" }), onClick: onExecute, isLoading: isExecutingWargame, isDisabled: !isExecutionAllowed }, "Execute")),
        React.createElement("br", null),
        React.createElement("div", null,
            React.createElement(Link, { to: "../template-details?id=" + wargamePlan.id }, "View Plan")),
        React.createElement(FormModal, { isOpen: isRemoveConfirmationVisible, onClose: hideRemoveConfirmation, heading: "Remove Wargame Plan", width: "small", actions: {
                submit: {
                    text: "Confirm",
                    onSubmit: removeWargamePlan,
                    isSubmitting: isRemovingWargamePlan
                },
                close: {
                    text: "Cancel",
                    onClose: hideRemoveConfirmation
                }
            } },
            "Are you sure you want to remove ",
            wargamePlan.name,
            " from this exercise?")));
};
var Header = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var useExecuteWargame = function (wargamePlanId, wargameExerciseId) {
    var _a = useMutationUI({
        mutation: StartWargameMutation,
        options: {
            variables: {
                wargameInput: {
                    warGameTemplateId: wargamePlanId,
                    wargameExerciseId: wargameExerciseId,
                    scheduleInfo: { scheduleType: ScheduleType.none }
                }
            }
        },
        successMessage: "Wargame will start in a few seconds"
    }), mutate = _a.mutate, isLoading = _a.isLoading;
    var executeWargame = function () { return mutate(); };
    return {
        isExecutingWargame: isLoading,
        executeWargame: executeWargame
    };
};
var useRemoveWargamePlan = function (wargamePlanId, wargameExerciseId, onCompleted) {
    var _a = useMutationUI({
        mutation: DisableExerciseTemplateMappingMutation,
        options: {
            variables: {
                exerciseID: wargameExerciseId,
                templateID: wargamePlanId.toString()
            },
            refetchQueries: ["wargameExerciseMasterData"],
            awaitRefetchQueries: true,
            onCompleted: onCompleted
        },
        successMessage: "Wargame plan removed successfully"
    }), mutate = _a.mutate, isLoading = _a.isLoading;
    return {
        removeWargamePlan: mutate,
        isRemovingWargamePlan: isLoading
    };
};
var templateObject_1;
